import { RowClickedEvent } from '@ag-grid-community/core'
import { DataTablePagination } from 'components/common'
import DataTable from 'components/common/dataTable'
import { useQuery } from 'hooks'
import { useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { SetSelectedColumns } from 'types/dataTable'
import { fetchEcomPricings } from 'utils/api/ecomPricingApi'
import { PAGE_ECOM_PRICING_DATA } from 'utils/constants'
import { columns } from './utils'

interface EcomPricingDataTableProps {
  isEditor: boolean
  setSelectedColumns: SetSelectedColumns
  loading: boolean
  setLoading: React.Dispatch<React.SetStateAction<boolean>>
}

const EcomPricingDataTable = ({
  isEditor,
  setSelectedColumns,
  loading,
  setLoading,
}: EcomPricingDataTableProps) => {
  const [ecomPricingResponse, setEcomPricingResponse] = useState<any>({})

  const navigate = useNavigate()
  const { search } = useLocation()
  const { getAllQueries, setQuery } = useQuery()

  // To fetch pricing Data
  const getEcomPricingData = async () => {
    setLoading(true)
    const { limit, page, search, ecomPricingFilters } = getAllQueries()
    try {
      const { data } = await fetchEcomPricings({
        limit: limit || 10,
        page: page || 1,
        search: search,
        filters: ecomPricingFilters,
      })

      setSelectedColumns(data?.tableConfig?.ecompricing || [])
      setEcomPricingResponse({ ...data })
    } catch (error) {
      setEcomPricingResponse({ docs: [] })
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    getEcomPricingData()
  }, [search])

  useEffect(() => {
    const columnUrlParams = localStorage.getItem('ecompricingColumnSelected')
    if (columnUrlParams) {
      setQuery('cols', JSON.parse(columnUrlParams))
    }
  }, [])

  // Will redirect to edit form
  const redirectToEdit = (e: RowClickedEvent) => {
    if (!isEditor) return
    navigate(`${PAGE_ECOM_PRICING_DATA.path}/${e.data._id}`)
  }
  return (
    <>
      {/* Table */}

      <DataTable
        columns={loading ? [] : columns}
        rows={loading ? null : ecomPricingResponse.docs}
        identifier="_id"
        onRowClicked={isEditor ? redirectToEdit : () => {}}
        activeColumns={ecomPricingResponse?.tableConfig?.ecompricing || []}
        activeColumnsKey="ecompricing"
      />

      {/* Table Pagination */}
      <DataTablePagination
        currentPage={ecomPricingResponse?.page}
        totalPages={ecomPricingResponse?.totalPages}
        hasNextPage={ecomPricingResponse?.hasNextPage}
        hasPrevPage={ecomPricingResponse?.hasPrevPage}
        limit={ecomPricingResponse?.limit}
        nextPage={ecomPricingResponse?.nextPage}
        prevPage={ecomPricingResponse?.prevPage}
        disabled={loading}
        shouldDisplayTotalPages={false}
        disableGoToLastPage
      />
    </>
  )
}

export default EcomPricingDataTable
